// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2236R","toggle":"styles_toggle__1oRN6","preview":"styles_preview__1s953"};